var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "CardHoddy" } },
    [
      _c("shop-header", { attrs: { path: _vm.path } }),
      _vm._v(" "),
      _c(
        "div",
        {
          on: {
            mouseenter: function($event) {
              return _vm.hideMenu()
            }
          }
        },
        [_c("router-view")],
        1
      ),
      _vm._v(" "),
      _c("shop-footer", { attrs: { isPath: _vm.isPath } }),
      _vm._v(" "),
      _vm.istop
        ? _c("div", { attrs: { id: "ScrollAll" } }, [
            _c("div", {
              staticClass: "scrollUp",
              on: {
                click: function($event) {
                  return _vm.scrollBox(0)
                }
              }
            })
          ])
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-ecebbf8c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ecebbf8c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/layout.vue
// module id = null
// module chunks = 